import { TreeNode } from "primeng/api";
import { Tree } from "primeng/tree";
import { ArrayOrSingle } from "src/modules/sm-base/shared/array-or-single.model";
import { Arrays } from "../shared/arrays";
import { GuiUtils } from "./gui-utils";
import { TreeNode2 } from "./tree-node2.model";

export class TreeSelectionHelper {

    tree: Tree;
    items: TreeNode2[] = [];
    selected: ArrayOrSingle<TreeNode> = [];
    currentlyUnselectable: any[] = [];
    dataIsKey = true;

    constructor(tree: Tree, dataIsKey = true) {
        this.tree = tree;
        this.dataIsKey = dataIsKey;
    }

    private getKey(node: TreeNode2): any {
        return this.dataIsKey ? node.data : node.key;
    }

    getNode(data: any): TreeNode2 {
        return GuiUtils.flattenTree(this.items).find(node => this.getKey(node) == data);
    }

    setSelected(selected: any[]): void {
        this.selected = GuiUtils.flattenTree(this.items).filter(node => selected.find(item => this.getKey(node)  == item) != null);
        for (let node of Arrays.as(this.selected)) {
            (node as any).selected = true;
        }
        for (let node of this.items) {
            this.updatePartiallySelected(node);
        }
    }

    getSelectedNodes(): TreeNode2[] {
        return Arrays.as(this.selected);
    }

    getSelected(): any[] {
        return this.getSelectedNodes().map(node => this.getKey(node));
    }

    setItems(items: TreeNode2[], applyUnselectable = false): void {
        let oldSel: any[] = null;
        let oldUnsel: any[] = null;
        let flatNodes = GuiUtils.flattenTree(items);
        if (applyUnselectable) {
            oldUnsel = [...this.currentlyUnselectable];
            oldSel = [...this.getSelectedNodes()];
            this.currentlyUnselectable = this.getSelectedNodes().filter(node => flatNodes.find(node2 => node2.key == node.key) == null);
            this.selected = Arrays.withoutNull(this.getSelectedNodes().map(node => flatNodes.find(node2 => node2.key == node.key)));
        }
        let ex = Arrays.withoutNull(GuiUtils.flattenTree(this.items).filter(node => node.expanded).map(node => flatNodes.find(node2 => node.key == node2.key)));
        this.items = items;
        if (applyUnselectable) {
            this.selected = Arrays.withoutNull([...oldSel, ...oldUnsel].map(node => flatNodes.find(node2 => node2.key == node.key)));
            for (let node of flatNodes) {
                (node as any).selected = false;
            }
            for (let node of this.getSelectedNodes()) {
                (node as any).selected = true;
            }
            for (let node of ex) {
                node.expanded = true;
            }
            for (let node of this.items) {
                this.updatePartiallySelected(node);
            }
        }
    }

    private updatePartiallySelected(node: TreeNode2): void {
        let anySel = false;
        let anyUnsel = false;
        for (let child of node.children ?? []) {
            this.updatePartiallySelected(child);
            anySel ||= (child as any).selected; 
            anyUnsel ||= !(child as any).selected;
        }
        node.partialSelected = anySel && anyUnsel;
        if (node.children != null) {
            (node as any).selected = anySel && !anyUnsel;
            if (Arrays.is(this.selected)) {
                if ((node as any).selected) {
                    if (!(this.selected as TreeNode[]).some(n => n.key == node.key)) {
                        (this.selected as TreeNode[]).push(node);
                    }
                }
                else {
                    this.selected = (this.selected as TreeNode[]).filter(n => n.key != node.key);
                }
            }
        }
    }

}
